import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

import {UserActivityPageData} from "./user-activity-page-data";
import {UserActivityDashboardList} from "./user-activity-dashboardList";
import {UserActivityPage} from "./user-activity-page";

/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class UserActivityResultService {
    listData:any;
    loginData;
    rows = {};
    applicationsDashboardData = {};

    constructor(){}

    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: UserActivityPage,listData): Observable<UserActivityPageData<UserActivityDashboardList>> {
        this.listData = listData;
        return Observable.of(listData).map(data => this.getPageData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPageData(page: UserActivityPage): UserActivityPageData<UserActivityDashboardList> {
        let pageData = new UserActivityPageData<UserActivityDashboardList>();
        let offset = this.listData.offset;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.totalCount){
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);

        
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                
                    let list = new UserActivityDashboardList(jsonObj['username'], jsonObj['createdAt'],
                        jsonObj['description'], jsonObj['email'], jsonObj['wpassId']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-activity-logs/user-activity-datatable/userActivityResultService.ts